import React from 'react';
import { useTranslation } from 'react-i18next';

import { selectCountry, selectCurrentUser } from 'store/user/selectors';
import { selectCancellationCandidate } from 'store/subscriptions/selectors';
import { setCancellationCandidate } from 'store/subscriptions/actions';
import { openModal, closeModal } from 'store/modals/actions';

import { useSelector, useDispatch } from 'react-redux';

import { normalizeDateByLocale } from 'helpers/normalizeDateByLocale';

import AlertModal from 'modals/AlertModal';

import { ModalName } from 'types/modals';

const AlertModalContainer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const country = useSelector(selectCountry);
    const { expired_date } = useSelector(selectCancellationCandidate);
    const { timezone } = useSelector(selectCurrentUser);
    const expirationDate = normalizeDateByLocale({ date: expired_date, country, timezone });

    const onSubmit = () => {
        dispatch(openModal(ModalName.FREEZE_ALERT_MODAL));
    };

    const discardCancellationHandler = () => {
        dispatch(closeModal());

        dispatch(setCancellationCandidate(null));
    };

    return (
        <AlertModal
            onDiscard={discardCancellationHandler}
            onSubmit={onSubmit}
            captions={{
                title: t('subscription.cancelDialog.title'),
                description: t('subscription.cancelDialog.description', { date: expirationDate }),
                submitButton: t('subscription.text.cancel'),
                discardButton: t('subscription.cancelDialog.discard'),
            }}
            dataLocator="cancelSubModal"
        />
    );
};

export default AlertModalContainer;
